import { Route } from 'react-router-dom';
import { withSentryRouting } from '@sentry/react';
export var SentryRoute = withSentryRouting(Route);
